import { render, staticRenderFns } from "./Comp3.vue?vue&type=template&id=5f10fdd2&scoped=true"
import script from "./Comp3.vue?vue&type=script&lang=ts"
export * from "./Comp3.vue?vue&type=script&lang=ts"
import style0 from "./Comp3.vue?vue&type=style&index=0&id=5f10fdd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f10fdd2",
  null
  
)

export default component.exports